import { Link, useRouteError } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { isAuthenticated } from '../../auth/storage';

export default function NotFound() {
    // Serve tanto de rota "*" quanto de errorElement (erro de rota).
    const err = useRouteError?.();
    if (err) console.error('Erro de rota:', err);
    const logado = isAuthenticated();

    return (
        <div className="ueb-notfound">
            <div className="ueb-notfound-card">
                <span className="ueb-notfound-ico"><Compass size={40} /></span>
                <h1>Página não encontrada</h1>
                <p>O endereço que você tentou abrir não existe ou foi movido.</p>
                <Link className="pbtn pbtn--primary" to={logado ? '/' : '/login'}>
                    {logado ? 'Ir para o início' : 'Ir para o login'}
                </Link>
            </div>
        </div>
    );
}
